import { render, staticRenderFns } from "./form-script.vue?vue&type=template&id=d5702ba6&"
import script from "./form-script.vue?vue&type=script&lang=js&"
export * from "./form-script.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports